import { isGeoLocationLeaf, isRegionGeoLocation, renderForCriticalMoment, renderForGeoLocation } from '../../dashHelper'

// Defaults
import defaultCommonWidgets from './default'
import defaultHospitalesWidgets from './defaultHospitales'
import defaultCediasaWidgets from './defaultCediasa'
import defaultClinicasWidgets from './defaultClinicas'
import defaultLaboratoriosWidgets from './defaultLaboratorios'
import defaultHospitalesLeafWidgets from './defaultHospitalesLeaf'

// Dashboards
import durante from './durante'
import posterior from './posterior'
import posterior2 from './posterior2'
import laboratorioServiciosSubrogados from './laboratorioServiciosSubrogados'
import serviciosAccesosVasculares from './serviciosAccesosVasculares'
import conveniosSubrogadosHemodialisis from './conveniosSubrogadosHemodialisis'
import laboratoriosMedicosSolicitantes from './laboratoriosMedicosSolicitantes'
import serviciosExternosDiagnostico from './serviciosExternosDiagnostico'
import servicioHemodialisisAmbulatoria from './servicioHemodialisisAmbulatoria'
import useClientConfig from 'config/clients/useClientConfig'
import { getHaGeoId, isHaGeoServiciosExternos } from '../commonWidgetsHa'
import test from './test'
import serviciosExternosCheckUp from './serviciosExternosCheckUp'

export default {
    title: 'Demo Dashboard',
    description: 'Dashboard de perfil Demo',
    backgroundClassName: (filters) => 'epsilon-hero-bg',
    widgets: (filters: FiltersUI, filtersData: Record<string, any>) => {
        const { getCriticalMomentsRootId, getGeosRootId } = useClientConfig()
        const cmRootId = getCriticalMomentsRootId()
        const geosRootId = getGeosRootId()

        //console.log('RENDERING WORKFLOWS BY GEO!!!!')
        //console.log(filtersData)

        return [
            ...defaultHospitalesWidgets.widgets(filters)
                //...test.widgets(filters)
                .map((wdg) => ({
                    ...wdg,
                    render: (filters: FiltersUI) => {
                        const hostMetroId = getHaGeoId('hospitales-metro')
                        const hostForanId = getHaGeoId('hospitales-for')
                        return renderForCriticalMoment(filters, [cmRootId, 0])
                            && (renderForGeoLocation(filters, [geosRootId, 0])
                                || isRegionGeoLocation(filters, filtersData, [hostMetroId, hostForanId]))
                            && !isHaGeoServiciosExternos(filters)
                    },
                })),
            ...defaultHospitalesLeafWidgets.widgets(filters)
                .map((wdg) => ({
                    ...wdg,
                    render: (filters: FiltersUI) => {
                        const hostMetroId = getHaGeoId('hospitales-metro')
                        const hostForanId = getHaGeoId('hospitales-for')
                        return renderForCriticalMoment(filters, [cmRootId, 0])
                            && isGeoLocationLeaf(filters, filtersData)
                            && isRegionGeoLocation(filters, filtersData, [hostMetroId, hostForanId])
                            && !isHaGeoServiciosExternos(filters)
                    }
                    ,
                })),
            ...defaultCediasaWidgets.widgets(filters)
                .map((wdg) => ({
                    ...wdg,
                    render: (filters: FiltersUI) => {
                        return renderForCriticalMoment(filters, [cmRootId, 0])
                            && (renderForGeoLocation(filters, [geosRootId, 0])
                                || isRegionGeoLocation(filters, filtersData, [getHaGeoId('cediasa')]))
                            && !isHaGeoServiciosExternos(filters)
                    },
                })),
            ...defaultLaboratoriosWidgets.widgets(filters)
                .map((wdg) => ({
                    ...wdg,
                    render: (filters: FiltersUI) => {
                        return renderForCriticalMoment(filters, [cmRootId, 0])
                            && (renderForGeoLocation(filters, [geosRootId, 0])
                                || isRegionGeoLocation(filters, filtersData, [getHaGeoId('laboratorios')]))
                            && !isHaGeoServiciosExternos(filters)
                    },
                })),
            ...defaultClinicasWidgets.widgets(filters)
                .map((wdg) => ({
                    ...wdg,
                    render: (filters: FiltersUI) => {
                        return renderForCriticalMoment(filters, [cmRootId, 0])
                            && (renderForGeoLocation(filters, [geosRootId, 0])
                                || isRegionGeoLocation(filters, filtersData, [getHaGeoId('clinicas')]))
                            && !isHaGeoServiciosExternos(filters)
                    },
                })),
            ...defaultCommonWidgets.widgets(filters)
                .map((wdg) => ({
                    ...wdg,
                    render: (filters: FiltersUI) => renderForCriticalMoment(filters, [cmRootId, 0])
                        && !isGeoLocationLeaf(filters, filtersData) && !isHaGeoServiciosExternos(filters),
                })),
            ...durante.widgets(filters)
                .map((wdg) => {
                    return ({
                        ...wdg,
                        render: (filters: FiltersUI) => renderForCriticalMoment(filters, [9951])
                            && !isHaGeoServiciosExternos(filters),
                    })
                }),
            ...posterior.widgets(filters)
                .map((wdg) => {

                    return ({
                        ...wdg,
                        render: (filters: FiltersUI) => renderForCriticalMoment(filters, [10301])
                            && !isHaGeoServiciosExternos(filters),
                    })
                }),
            ...posterior2.widgets(filters)
                .map((wdg) => {

                    return ({
                        ...wdg,
                        render: (filters: FiltersUI) => renderForCriticalMoment(filters, [11301])
                            && !isHaGeoServiciosExternos(filters),
                    })
                }),
            ...laboratorioServiciosSubrogados.widgets(filters)
                .map((wdg) => {

                    return ({
                        ...wdg,
                        render: (filters: FiltersUI) => renderForCriticalMoment(filters, [11656])
                            && !isHaGeoServiciosExternos(filters),
                    })
                }),
            ...serviciosAccesosVasculares.widgets(filters)
                .map((wdg) => {

                    return ({
                        ...wdg,
                        render: (filters: FiltersUI) => renderForCriticalMoment(filters, [11655])
                            && !isHaGeoServiciosExternos(filters),
                    })
                }),
            ...conveniosSubrogadosHemodialisis.widgets(filters)
                .map((wdg) => {

                    return ({
                        ...wdg,
                        render: (filters: FiltersUI) => renderForCriticalMoment(filters, [12052])
                            && !isHaGeoServiciosExternos(filters),
                    })
                }),
            ...laboratoriosMedicosSolicitantes.widgets(filters)
                .map((wdg) => {

                    return ({
                        ...wdg,
                        render: (filters: FiltersUI) => renderForCriticalMoment(filters, [11652])
                            && !isHaGeoServiciosExternos(filters),
                    })
                }),
            ...servicioHemodialisisAmbulatoria.widgets(filters)
                .map((wdg) => {

                    return ({
                        ...wdg,
                        render: (filters: FiltersUI) => renderForCriticalMoment(filters, [11653])
                            && !isHaGeoServiciosExternos(filters),
                    })
                }),
            ...serviciosExternosDiagnostico.widgets(filters)
                .map((wdg) => {

                    return ({
                        ...wdg,
                        render: (filters: FiltersUI) => renderForCriticalMoment(filters, [12051])
                            || isHaGeoServiciosExternos(filters),
                    })
                }),
            /*...serviciosExternosCheckUp.widgets(filters)
                .map((wdg) => {

                    return ({
                        ...wdg,
                        render: (filters: FiltersUI) => renderForCriticalMoment(filters, [-12051])
                            || isHaGeoServiciosExternos(filters),
                    })
                }),*/

        ]
    },
} as DasboardConfig
